import { render } from "./xfsFb1.vue?vue&type=template&id=0c9d8e42&scoped=true"
import script from "./xfsFb1.vue?vue&type=script&lang=js"
export * from "./xfsFb1.vue?vue&type=script&lang=js"

import "./xfsFb1.vue?vue&type=style&index=0&id=0c9d8e42&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9d8e42"]])

export default __exports__